/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payoutKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType } from '../../shared/api/kyMutator';
import {
    type GoogleRpcStatus,
    type PayoutTraderV1BalanceResponse,
    type PayoutTraderV1GetMeResponse,
    type PayoutTraderV1GetRateResponse,
    type PayoutTraderV1RegisterRequest,
    type PayoutTraderV1RegisterResponse,
    type PayoutTraderV1SetWorkingStatusRequest,
    type PayoutTraderV1SetWorkingStatusResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить информацию о профиле трейдера.
 */
export const getTraderPayoutTraderServiceGetMeUrl = () => {
    return '/v1/trader';
};

export const traderPayoutTraderServiceGetMe = async (options?: RequestInit): Promise<PayoutTraderV1GetMeResponse> => {
    return payoutKyMutator<PayoutTraderV1GetMeResponse>(getTraderPayoutTraderServiceGetMeUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayoutTraderServiceGetMeQueryKey = () => {
    return ['/v1/trader'] as const;
};

export const getTraderPayoutTraderServiceGetMeQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>, TError, TData>>;
    request?: SecondParameter<typeof payoutKyMutator>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayoutTraderServiceGetMeQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>> = ({ signal }) =>
        traderPayoutTraderServiceGetMe({ signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayoutTraderServiceGetMeQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>
>;
export type TraderPayoutTraderServiceGetMeQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayoutTraderServiceGetMe<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutTraderServiceGetMe<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutTraderServiceGetMe<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить информацию о профиле трейдера.
 */

export function useTraderPayoutTraderServiceGetMe<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetMe>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayoutTraderServiceGetMeQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Подать заявку на регистрацию в качестве выплатного трейдера.
 */
export const getTraderPayoutTraderServiceRegisterUrl = () => {
    return '/v1/trader';
};

export const traderPayoutTraderServiceRegister = async (
    payoutTraderV1RegisterRequest: PayoutTraderV1RegisterRequest,
    options?: RequestInit,
): Promise<PayoutTraderV1RegisterResponse> => {
    return payoutKyMutator<PayoutTraderV1RegisterResponse>(getTraderPayoutTraderServiceRegisterUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutTraderV1RegisterRequest),
    });
};

/**
 * @summary Получить баланс трейдера.
 */
export const getTraderPayoutTraderServiceBalanceUrl = () => {
    return '/v1/trader/balance';
};

export const traderPayoutTraderServiceBalance = async (
    options?: RequestInit,
): Promise<PayoutTraderV1BalanceResponse> => {
    return payoutKyMutator<PayoutTraderV1BalanceResponse>(getTraderPayoutTraderServiceBalanceUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayoutTraderServiceBalanceQueryKey = () => {
    return ['/v1/trader/balance'] as const;
};

export const getTraderPayoutTraderServiceBalanceQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>, TError, TData>>;
    request?: SecondParameter<typeof payoutKyMutator>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayoutTraderServiceBalanceQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>> = ({ signal }) =>
        traderPayoutTraderServiceBalance({ signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayoutTraderServiceBalanceQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>
>;
export type TraderPayoutTraderServiceBalanceQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayoutTraderServiceBalance<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutTraderServiceBalance<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutTraderServiceBalance<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить баланс трейдера.
 */

export function useTraderPayoutTraderServiceBalance<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceBalance>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayoutTraderServiceBalanceQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Получить текущий курс USDT/RUB (количество рублей за 1 USDT).
 */
export const getTraderPayoutTraderServiceGetRateUrl = () => {
    return '/v1/trader/rate';
};

export const traderPayoutTraderServiceGetRate = async (
    options?: RequestInit,
): Promise<PayoutTraderV1GetRateResponse> => {
    return payoutKyMutator<PayoutTraderV1GetRateResponse>(getTraderPayoutTraderServiceGetRateUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayoutTraderServiceGetRateQueryKey = () => {
    return ['/v1/trader/rate'] as const;
};

export const getTraderPayoutTraderServiceGetRateQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>, TError, TData>>;
    request?: SecondParameter<typeof payoutKyMutator>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayoutTraderServiceGetRateQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>> = ({ signal }) =>
        traderPayoutTraderServiceGetRate({ signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayoutTraderServiceGetRateQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>
>;
export type TraderPayoutTraderServiceGetRateQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayoutTraderServiceGetRate<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutTraderServiceGetRate<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayoutTraderServiceGetRate<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить текущий курс USDT/RUB (количество рублей за 1 USDT).
 */

export function useTraderPayoutTraderServiceGetRate<
    TData = Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayoutTraderServiceGetRate>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayoutTraderServiceGetRateQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Встать в трфик.
 */
export const getTraderPayoutTraderServiceSetWorkingStatusUrl = () => {
    return '/v1/trader/working_status';
};

export const traderPayoutTraderServiceSetWorkingStatus = async (
    payoutTraderV1SetWorkingStatusRequest: PayoutTraderV1SetWorkingStatusRequest,
    options?: RequestInit,
): Promise<PayoutTraderV1SetWorkingStatusResponse> => {
    return payoutKyMutator<PayoutTraderV1SetWorkingStatusResponse>(getTraderPayoutTraderServiceSetWorkingStatusUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutTraderV1SetWorkingStatusRequest),
    });
};
